<template>
  <settings-modal class="postponed-swift-payment-return-on-hold-modal">
    <template slot="heading">Return to on hold payment {{ paymentId }}?</template>
    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close </v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PostponedSwiftPaymentReturnOnHoldModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        returnToOnHoldApiRequest: new ApiRequest(PaymentApi.returnToOnHoldPostponedSwiftByAccountant)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      loading () {
        return this.returnToOnHoldApiRequest.loading
      },
      error () {
        return this.returnToOnHoldApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.returnToOnHoldApiRequest.execute(this.paymentId)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Payment has been successfully updated' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      filterDate (date) {
        return this.allowedValueDates.includes(date)
      }
    }
  }
</script>
